//
//
//
//
//
//
//
//

export default {
	data () {
		return {
		}
	},
	computed: {
		isShow () {
			return this.$store.state.isShow
		},
		content () {
			return this.$store.state.content
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/modalHint.vue